<template>
  <router-view />
</template>
<script setup lang="ts">
import { loadScriptAsync } from "@hiijs/utils-plus";
import { onMounted } from "vue";
import { useRoute } from "vue-router";

function installAili() {
  if (import.meta.env.MODE === "production") {
    // @ts-ignore
    window.__rum = {
      pid: "ddj1truonn@20650a7ee8e9266",
      endpoint: "https://ddj1truonn-default-cn.rum.aliyuncs.com",
      // 设置环境信息，参考值：'prod' | 'gray' | 'pre' | 'daily' | 'local'
      env: "prod",
      // 设置路由模式， 参考值：'history' | 'hash'
      spaMode: "history",
    };
    loadScriptAsync("https://sdk.rum.aliyuncs.com/v2/browser-sdk.js");
  }
}

function installGoogleAnalytics() {
  // @ts-ignore
  loadScriptAsync("https://www.googletagmanager.com/gtag/js?id=G-E0SLZ6PTEF");
  const scriptElGoogleAnalytics = document.createElement("script");
  scriptElGoogleAnalytics.innerHTML = `(function() {
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-E0SLZ6PTEF');
    })()`;
  document.body.append(scriptElGoogleAnalytics);
}

function installBaiduAnalytics() {
  const scriptEl = document.createElement("script");
  // const scriptEl2 = document.createElement('script');
  scriptEl.innerHTML = `var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?3c6f688af28e6b03770b9cd19d20b0af";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();`;

  document.body.append(scriptEl);
}

onMounted(() => {
  const route = useRoute();
  if (
    import.meta.env.VITE_API_MODE === "production" &&
    !route.meta.skipAnalytics
  ) {
    installAili();
    installGoogleAnalytics();
    installBaiduAnalytics();
  }
});
</script>
<style></style>
